import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../../context/AuthContext";
import FuturHealthLegacyAPI from "../../utils/FuturHealthLegacyAPI";

export const useGetLegacyApiUser = (readyToLoad?: boolean) => {
  const { legacyApiUserToken } = useAuth();

  return useQuery({
    queryKey: ["legacy api", "get user"],
    queryFn: () => FuturHealthLegacyAPI.checkAuth(legacyApiUserToken),
    enabled: !!readyToLoad && !!legacyApiUserToken,
  });
};
